module.exports = __webpack_public_path__ + "img/loader-dark.b5fbc474.png";